export function quicklinkFilter() {
  let tabs = document.querySelectorAll('.js-tab');

  tabs.forEach((tab) => {
    let quicklinks = tab.querySelectorAll('.js-content');
    quicklinks.forEach(element => {
      element.addEventListener('click', (event: Event) => {
        quicklinks.forEach(el => {
          el.classList.remove('active');
        });

        if (element instanceof HTMLElement) {
          element.classList.add('active');
        }
      });
    });
  });
}
